import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-attendees-editor',
  templateUrl: './attendees-editor.component.html',
  styleUrls: ['./attendees-editor.component.scss'],
})
export class AttendeesEditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
